function state() {
  return {
    colorTheme: "",
    logo: "",
    sidebarMenuDefault: "",
    sidebarMenu: "",
    headerPolicies: "",
    headerClaims: "",
    previousAccount: "",
    locale: "",
    headerTableColumn: "",
    platformConfigFilter: {},
    internalToolsFilter: {},
  };
}

export default state;
